import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {  Button, Modal, Label, TextInput, } from "flowbite-react";
import axios from "axios";
import "sweetalert2/dist/sweetalert2.css";
import { useSidebar } from "../context/SidebarOpenContext";
import { AuthContext } from "../context/AuthContext";
import ReusableExpandableDataTable from "../hooks/ReusableExpandableDataTable";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

const ExpandedComponent = ({ data }) => {
    const logDetails = data?.log_details;

    if (!logDetails) {
        return <p className="text-red-500">No log details available</p>;
    }

    return (
        <div className="p-4">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                <div>
                    <p className="text-sm">
                        <span className="font-semibold pr-2">Order Date : </span> {new Date(data.order_date).toLocaleDateString('en-GB')}
                    </p>
                    <p className="text-sm">
                        <span className="font-semibold pr-2">Order Number : </span> {data.order_no}
                    </p>
                </div>
                <div className="pt-2">
                    <p className="text-sm">
                        <span className="font-semibold pr-2">Buyer Name : </span> {data.buyer_name}
                    </p>
                    {data.section_name !=='GroupBoxing'  && 
                    <p className="text-sm flex items-center">
                        <span className="font-semibold pr-2">Color : </span>

                        <div className="flex items-center space-x-2">
                            <div className="flex items-center justify-center">
                                <img
                                    src={data.color_image}
                                    alt={data.color_image}
                                    className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md"
                                />
                            </div>
                            <span>{data.color_name}</span>
                        </div>

                    </p>}
                </div>
            </div>
            <p className="text-center p-2">{data.section_name}</p>
            <table className="table-auto w-full border-collapse border border-gray-300 text-xs text-center">
                <thead>
                    <tr className="bg-gray-200">
                        {Object.keys(logDetails).map((key) => (
                            <th key={key} className="border border-gray-300 px-4 py-2">
                                {key.replace(/_/g, " ").toUpperCase()}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {Object.entries(logDetails).map(([key, value], index) => {
                            const formattedValue = key.toLowerCase().includes("date") && !isNaN(Date.parse(value))
                                ? new Date(value).toLocaleDateString('en-GB')
                                : typeof value === "object"
                                    ? JSON.stringify(value, null, 2)
                                    : value;

                            return (
                                <td key={index} className="border border-gray-300 px-4 py-2">
                                    {formattedValue}
                                </td>
                            );
                        })}
                    </tr>
                </tbody>

            </table>
        </div>

    );
};

function Request() {
    const url = localStorage.getItem("url");
    const navigate = useNavigate();
    const [requests, Setrequests] = useState([]);
    const { isSidebarOpen } = useSidebar();
    const { user } = useContext(AuthContext);
    const [rejectModal, setrejectModal] = useState(false);
    const [requestId, setrequestId] = useState("");
    const [reason, setreason] = useState("");


    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            fetchrequest();
        }
    }, [user, navigate]);

    const onChangeValue = (e) => {
        setreason(e.target.value );
    };

    const fetchrequest = async () => {
        try {
            const response = await axios.get("/requests/requests");
            Setrequests(response.data);
        } catch (error) {
            console.error("Error fetching requests data:", error);
        }
    };


    const handleAccept = async (request_id) => {
        try {
            axios
                .put(`requests/accept/${request_id}`)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Accepted",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        fetchrequest();
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }
    };

    const handleReject = async (e) => {
        e.preventDefault();
        setrejectModal(false)
        try {
            const response = await axios.put(`requests/reject/${requestId}`, { reason });
    
            if (response.data.success === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Rejected",
                    timer: 2000,
                    showConfirmButton: false,
                });
                fetchrequest();
            } else {
                Swal.fire({
                    icon: "error",
                    text: "Server Problem. Please Try Again...",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            console.error("Error rejecting request:", error);
            Swal.fire({
                icon: "error",
                text: "Something went wrong. Please try again.",
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };
    

    const data = Array.isArray(requests)
        ? requests.map((requests) => ({
            id: requests.request_id,
            requestsdate: new Date(requests.request_date_time).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }),
            staff_name: requests.staff_name,
            section_name: requests.section_name,
            log_details: requests.log_details,
            buyer_name: requests.buyer_name,
            color_image: `${url}${requests.color_image}`,
            color_name: requests.color_name,
            order_date: requests.order_date,
            order_no: requests.order_no,
            request_reason: requests.request_reason,
            option: (
                <div style={{ display: "flex" }}>
                    <p className="text-sm font-bold text-green-500 drop-shadow-xl cursor-pointer " onClick={() => handleAccept(requests.request_id)}>Accept</p>
                    <p className="pl-2 text-sm font-bold text-red-500 drop-shadow-xl cursor-pointer " onClick={() => { setrejectModal(true); setrequestId(requests.request_id); }}>Reject</p>
                </div>
            )
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Requested Date", selector: (row) => row.requestsdate, sortable: true },
        { name: "Requested Staff Name", selector: (row) => row.staff_name, sortable: true },
        { name: "Request Reason", selector: (row) => row.request_reason, sortable: true },
        { name: "Section Name", selector: (row) => row.section_name, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen" : "p-4 bg-content-bg min-h-screen"}`}>
            <div className="p-4 rounded-lg dark:bg-gray-700 mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <ReusableExpandableDataTable
                        title="Request List"
                        columns={columns}
                        data={data}
                        expandableRows
                        ExpandedComponent={ExpandedComponent}
                    />
                </div>

                <Modal
                    show={rejectModal}
                    size="md"
                    onClose={() => setrejectModal(false)}
                    popup
                >
                    <Modal.Header />
                    <Modal.Body>
                        <div className="text-center">
                            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                Are you sure you want to request admin access for editing?
                            </h3>

                        </div>
                        <div className="space-y-6">

                            <form>
                                <div>
                                    <div className="pt-2 text-left mb-2 block">
                                        <Label htmlFor="completed-date" value="Reason" />
                                    </div>
                                    <TextInput
                                        id="reason"
                                        name="reason"
                                        type="text"
                                        required
                                        autoComplete="off"
                                        onChange={onChangeValue}
                                    />
                                </div>

                                <div className="pt-3 w-full flex justify-center">
                                    <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit" onClick={(e) => handleReject(e)}>
                                        Yes
                                    </Button>
                                    <Button className="ml-2" color="gray" onClick={() => setrejectModal(false)}>
                                        No
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
}

export default Request;
